import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// --- Silence benign ResizeObserver loop warnings emitted by 3rd-party widgets ---
// CRA's dev overlay treats this as an error even though it's harmless. We:
//   1. Wrap ResizeObserver callbacks in requestAnimationFrame (prevents the loop)
//   2. Swallow the error at window level as a safety net
if (typeof window !== "undefined" && typeof window.ResizeObserver !== "undefined") {
  const OriginalRO = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalRO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          if (!Array.isArray(entries) || !entries.length) return;
          callback(entries, observer);
        });
      });
    }
  };

  const RESIZE_OBSERVER_ERR = /ResizeObserver loop/;
  window.addEventListener(
    "error",
    (e) => {
      if (e?.message && RESIZE_OBSERVER_ERR.test(e.message)) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return false;
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
